'use client'

import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useTranslations } from 'next-intl'

type ReportConfirmationModalProps = {
  open?: boolean
  onAction?: () => void
}

export default function ReportConfirmationModal({
  open = false,
  onAction,
}: ReportConfirmationModalProps) {
  const t = useTranslations()
  return (
    <DefaultAlertDialog
      open={open}
      title={t('report-confirmation-modal.title')}
      description={t('report-confirmation-modal.description')}
      actionText={t('report-confirmation-modal.action')}
      onAction={onAction}
      allowOutsideInteraction={true}
    />
  )
}
